import { ContainerCard } from "../../../../../components/cards/containerCard";
import { InformationCard } from "../../../../../components/cards/infoCard";
import { BankAccounts } from "./bankAccounts";
import { Cards } from "./cards";

export const MemberBankAccount = () => {
  return (
    <div className="flex flex-row flex-wrap width-lim:flex-nowrap w-full gap-2 md:gap-6">
      <ContainerCard
        className="
          !w-full width-lim:max-w-[653px] width-lim:min-h-[635px]
          order-last width-lim:order-first px-0 md:px-0
          "
      >
        <BankAccounts className="border-b pb-8" />

        <Cards className="pt-8" />
      </ContainerCard>

      <InformationCard
        info={
          "Kindly ensure you add your personal bank account. This account will be used for withdrawals, loans etc. "
        }
        className="flex-1 width-lim:max-w-[345px] h-fit width-lim:sticky-top"
      />
    </div>
  );
};
